var exports = {
  "link": "x804f0401--9d400f--link",
  "link--white": "x804f0401--9d400f--link--white",
  "link--block": "x804f0401--9d400f--link--block",
  "link--fullwidth": "x804f0401--9d400f--link--fullwidth",
};

module.exports = exports;
